export default __webpack_public_path__ + "33075fcfad9baf2cfeebbe301d64ef5c.mtl";